import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useConfig from 'hooks/useConfig';
import { GuardProps } from 'types';
import useAuth from 'hooks/useAuth';
import useRouteGuard from 'hooks/useRouteGuard';
import { DASHBOARD_PATH, ONBOARDING_PATH } from 'config';

const SectionGuard = ({ children }: GuardProps) => {
    let { isReady: authReady, hasOnboarded } = useAuth();
    let { ready: configReady } = useConfig();

    let enabledPaths = useRouteGuard();
    let location = useLocation();
    let navigate = useNavigate();

    let path: string = location.pathname;
    let pathSplit: string[] = path.split('/');
    if (pathSplit.length === 4) {
        pathSplit.pop();
        path = pathSplit.join('/');
    }

    useEffect(() => {
        // Allow redirection from payments -> orders & funds -> payouts
        if (pathSplit[1] === 'payments') {
            return navigate(path.replace('payments', 'orders'), { replace: true });
        }
        if (pathSplit[1] === 'funds') {
            return navigate(path.replace('funds', 'payouts'), { replace: true });
        }

        if (authReady && configReady && !enabledPaths.includes(path)) {
            if (path.startsWith('/competitions')) {
                return navigate(path);
            }
            if (path === ONBOARDING_PATH && hasOnboarded) {
                navigate(DASHBOARD_PATH, { replace: true });
                return;
            }
            if (path !== ONBOARDING_PATH && !hasOnboarded) {
                navigate(ONBOARDING_PATH, { replace: true });
                return;
            }
            navigate('/pages/error', { replace: true });
        }
    }, [authReady, configReady, enabledPaths, path]);

    return children;
};
export default SectionGuard;
